// extracted by mini-css-extract-plugin
export default {"tag":"mpywTUEdZ4WXxMKpb2B3","label":"GDcMqU16BmJD3Dw2aMeg","removeButton":"iJ_m_9xJD1WWi5sKm7vl","disabled":"BSBVQpaMFxDLKX7xiEUD"};